import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../../store/useAppStore';
import { useBakerActionsEnabled } from '../../../hooks/useBakerActionsEnabled';
import { useMutationFeedback } from '../../../hooks/useMutationFeedback';
import { getDefaultDuration } from '../../../utils/bakingTime';

const PIZZA_STATES = ['queued', 'preparing', 'baking', 'done', 'served'];

function StateButtons({ order }) {
  const { t } = useTranslation();
  const enabled = useBakerActionsEnabled();
  const config = useAppStore((state) => state.config);
  const updateOrder = useAppStore((state) => state.updateOrder);
  const { run, fail } = useMutationFeedback();

  const handleChangeOrderState = async (nextState) => {
    if (nextState === 'baking' && order.half) {
      fail(t('state.halfMustJoin'));
      return;
    }
    const payload = { state: nextState };
    if (nextState === 'baking') payload.bakingDuration = getDefaultDuration(config);
    await run(
      () => updateOrder(order.id, payload),
      t('msg.stateChanged', { state: nextState }),
    );
  };

  // All transitions are blocked while the customer decides what to do about
  // out-of-stock toppings (enforced server-side as well).
  const waiting = order.state === 'queued' && order.awaitingCustomerAck;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="flex flex-wrap gap-1.5">
        {PIZZA_STATES.map((state) => (
          <button
            key={state}
            type="button"
            disabled={!enabled || waiting}
            className={`rounded-md border px-3 py-1.5 text-sm font-medium transition disabled:opacity-30 ${
              order.state === state
                ? 'border-emerald-500 bg-emerald-500 text-zinc-950'
                : 'border-[color:var(--app-border)] bg-[color:var(--app-card)] hover:border-emerald-500/60'
            }`}
            onClick={() => handleChangeOrderState(state)}
          >
            {t(`state.${state}`)}
          </button>
        ))}
      </div>
    </div>
  );
}

export default StateButtons;
